import { z } from "zod";

/** Response of POST schedule/send-messages/deferred — id used to undo the send. */
export const PendingSendResponseSchema = z.object({
	pendingSendId: z.string(),
});

export type PendingSendResponse = z.infer<typeof PendingSendResponseSchema>;

/** Response of POST schedule/pending-send/:id/cancel. */
export const PendingSendCancelResultSchema = z.object({
	pendingSendId: z.string(),
	canceled: z.boolean(),
});

export type PendingSendCancelResult = z.infer<typeof PendingSendCancelResultSchema>;
